import React from "react";


function CustomDropdown({ selected, setSelected, options, isActive, setIsActive, className }) {

    return (
        <div className={className}>
            <div className="dropdown-btn" onClick={e => setIsActive(!isActive)}><span className="dropdown-selected"> {selected.option}</span> <span className="dropdown-icon">ˇ</span></div>
            {isActive && (
                <div className="dropdown-content">
                    {options.map(option => (
                        <div className="dropdown-item" key={option.key} onClick={e => {
                            setSelected(
                                {
                                    "option": option.option,
                                    "key": option.key,
                                })
                            setIsActive(false);
                        }}>
                            {option.option}
                        </div>
                    ))}
                </div>
            )}
        </div>

    );
}

export default CustomDropdown;